<template>
  <div class="flex items-start justify-between p-3 mb-2 border rounded-lg">
    <div>
      <h4 class="mb-1 primary--text">
        <b>{{ typeString }}</b>
      </h4>
      <div>{{ $t('operation_date') }} : {{ dateString(suspend.issueDate) || "-" }}</div>
      <div>{{ $t('suspend.suspend_stall_or_sale') }} : {{suspendDateFormat()}}</div>
      <div>
        {{ $t('status') }} :
        <span :class="statusString.color">{{ statusString.text }}</span>
      </div>
    </div>
    <div class="text-right">
      <div class="py-1">
        <v-btn color="primary" elevation="0" @click="$emit('onView')" small>
          <v-icon left>mdi-eye</v-icon>{{ $t('detail') }}
        </v-btn>
      </div>
      <template v-if="status && suspend.isSuspend">
        <div class="py-1">
          <v-btn color="orange" elevation="0" dark outlined small @click="$emit('onEdit')">
            <v-icon left>mdi-pencil</v-icon>{{ $t('action_type.edit') }}
          </v-btn>
        </div>
        <div class="py-1">
          <v-btn color="red" elevation="0" dark outlined small @click="$emit('onRemove')">
            <v-icon left>mdi-calendar-remove-outline</v-icon>{{ $t('suspend.cancel_suspend_stall') }}
          </v-btn>
        </div>
      </template>
      <div class="py-1" v-if="!status && !suspend.isSuspend">
        <v-btn color="red" elevation="0" dark outlined small @click="$emit('onRemoved')">
          <v-icon left>mdi-delete</v-icon>{{ $t('delete_list_only') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    typeString() {
      let temp = this.suspendTypeLabel[this.suspend.type];
      if (
        this.suspend &&
        this.suspend.otherType &&
        this.suspend.type == "other"
      ) {
        temp = `${temp} [${this.suspend.otherType}]`;
      }
      return temp;
    },
    statusString() {
      let objectStatus = {};
      if (!this.suspend.isSuspend) {
        objectStatus.text = this.$t('suspend.no_suspend_stall');
        objectStatus.color = "black--text";
      } else {
        if(this.status){
          if(this.suspend.isSuspendSuccess){
            objectStatus.text = this.$t('suspend.stall_in_suspend');
            objectStatus.color = "green--text";
          }else{
            objectStatus.text = this.$t('suspend.wait_suspend_stall');
            objectStatus.color = "warning--text";
          }
        }else{
          objectStatus.text = this.$t('suspend.end_suspend_stall');
          objectStatus.color = "red--text";
        }
      }
      return objectStatus;
    }
  },
  data() {
    return {
      suspendTypeLabel: {}
    };
  },
  props: {
    suspend: Object,
    startDate: String,
    endDate: String,
    type: String,
    note: String,
    detail: String,
    status: Boolean
  },
  created() {
    this.suspendTypeLabel = {
      temporary: this.$t('suspend.type.temporary'),
      late: this.$t('suspend.type.late'),
      leave: this.$t('suspend.type.leave'),
      warn_1: this.$t('suspend.type.warn_1'),
      warn_2: this.$t('suspend.type.warn_2'),
      warn_3: this.$t('suspend.type.warn_3'),
      other: this.$t('suspend.type.other')
    };
  },
  methods: {
    dateString(date, format = "D MMMM YYYY") {
      let stringValue = "";
      if (date && date.iso) {
        stringValue = this.$moment(date.iso).format(format);
      } else if (date) {
        stringValue = this.$moment(date).format(format);
      }
      return stringValue;
    },
    suspendDateFormat(format = "D MMMM YYYY") {
      let text = "";
      if (this.suspend.isSuspend) {
        let startDate =
          this.suspend.startDate && this.suspend.startDate.iso
            ? this.suspend.startDate.iso
            : this.suspend.startDate;
        let endDate =
          this.suspend.endDate && this.suspend.endDate.iso
            ? this.suspend.endDate.iso
            : this.suspend.endDate;
        text = `${this.$moment(startDate).format(format)} ${this.$t('to')} ${this.$moment(
          endDate
        ).format(format)} (${this.diffDays()} ${this.$t('day')})`;
      } else {
        text = "-";
      }
      return text;
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (this.suspend && this.suspend.startDate && this.suspend.endDate) {
        let startDate =
          this.suspend.startDate && this.suspend.startDate.iso
            ? this.suspend.startDate.iso
            : this.suspend.startDate;
        let endDate =
          this.suspend.endDate && this.suspend.endDate.iso
            ? this.suspend.endDate.iso
            : this.suspend.endDate;
        minutes =
          this.$moment(endDate).diff(this.$moment(startDate), "minutes") || 0;
        days = Math.ceil(minutes / (24 * 60));
      }
      return days;
    }
  }
};
</script>

<style></style>
